<form class="opportunity-milestone-entry-body" [formGroup]="formGroup" [ngClass]="{'opportunity-milestone-entry-done': readonly}">

  <div class="opportunity-milestone-entry-top"
       [ngClass]="{
         'opportunity-milestone-entry-done': isDone() || readonly,
         'opportunity-milestone-entry-active': isActive() && !readonly
       }">
    <span>{{title}}</span>
  </div>

  <div class="opportunity-milestone-entry-center" [ngClass]="{'opportunity-milestone-entry-done': isDone() || readonly}">
    {{description}}
  </div>

  <div class="opportunity-milestone-entry-bottom" [ngClass]="{'opportunity-milestone-entry-done': readonly}">

    <div class="opportunity-milestone-entry-checkboxes">

      <div class="opportunity-milestone-entry-bottom-column">
        <span class="opportunity-milestone-entry-bottom-label" [ngClass]="{'opportunity-milestone-entry-bottom-label-changed': isRejectedDirty()}">
          Aborted
        </span>
        <digires-checkbox
          [formGroup]="formGroup"
          [formCtrlName]="getFormControlNameRejected()"
          [disabled]="isAcquired() || readonly"
          (onChange)="emitEvent()"
        ></digires-checkbox>
      </div>

      <div class="opportunity-milestone-entry-bottom-column">
        <span class="opportunity-milestone-entry-bottom-label" [ngClass]="{'opportunity-milestone-entry-bottom-label-changed': isAcquiredDirty()}">
          {{getEndOfProcessCheckboxLabel()}}
        </span>
        <digires-checkbox
          [formGroup]="formGroup"
          [formCtrlName]="getFormControlNameAcquired()"
          [disabled]="isRejected() || readonly"
          tooltipPosition="below"
          tooltip="{{getEndOfProcessCheckboxTooltip()}}"
          (onChange)="emitEvent()"
        ></digires-checkbox>

      </div>

    </div>

    <mat-form-field [ngClass]="{'opportunity-milestone-entry-date-hidden': isNotAvailable()}">
      <mat-label>{{getPlaceholderDate()}}</mat-label>
      <label>
        <input matInput type="date" formControlName="{{getFormControlNameDate()}}" [readonly]="readonly">
      </label>
      <mat-error>Mandatory</mat-error>
    </mat-form-field>

    <div *ngIf="!isPlausibilityWarning()" class="warning-triangle"></div>
    <mat-icon *ngIf="isPlausibilityWarning()"
              class="warning-triangle"
              [matTooltip]="getPlausibilityWarningTooltip()">
      warning
    </mat-icon>

  </div>

</form>
